(() => {
  const initForm = (form) => {
    if (!form || form.dataset.variantPricingReady) return;
    const root = form.closest('.rms-box-page');
    const selectors = Array.from(form.querySelectorAll('[data-variant-option]'));
    const idInput = form.querySelector('input[name="id"]');
    const price = form.querySelector('[data-selected-price]');
    const message = form.querySelector('[data-availability-message]');
    const button = form.querySelector('[name="add"]');
    if (!root || !selectors.length || !idInput || !price || !message || !button) return;
    const configs = Array.from(root.querySelectorAll('[data-variant-id]'));
    if (!configs.length) return;
    form.dataset.variantPricingReady = 'true';
    const updateVariant = () => {
      const selectedValues = selectors.map((selector) => selector.value);
      const selected = configs.find((item) =>
        selectedValues.every((value, index) => item.getAttribute(`data-option${index + 1}`) === value)
      );
      if (!selected) {
        button.disabled = true;
        message.textContent = 'Den valda kombinationen finns inte.';
        return;
      }
      idInput.value = selected.getAttribute('data-variant-id');
      idInput.dispatchEvent(new Event('input', { bubbles: true }));
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      price.textContent = selected.getAttribute('data-price');
      const available = selected.getAttribute('data-available') === 'true';
      button.disabled = !available;
      message.textContent = available ? '' : 'Den här varianten är för närvarande inte tillgänglig.';
    };
    selectors.forEach((selector) => selector.addEventListener('change', updateVariant));
    updateVariant();
  };
  const init = (root) => {
    if (root.matches && root.matches('.rms-box-page form')) initForm(root);
    root.querySelectorAll && root.querySelectorAll('.rms-box-page form').forEach(initForm);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();